import React, { useEffect, useState } from 'react'
import { Button, DotLoading, Toast } from 'antd-mobile-v5'
import Signature from '../../components/FormTools/Signature'
import { useGetOssSignature, useIeDetail, useIeOrientationDetail, useSubmitIeOrientation } from '../../services/hooks'
import { formatDate, getParameterByName, getSubmitOssFormat } from '../../components/common/utils'

import styles from './IeStatement.module.css'
import { Modal } from 'antd'
import { useIntl } from 'react-intl'

const IeOrientation = () => {
  const code = getParameterByName('code')
  const [signature, setSignature] = useState('')
  const { run, loading } = useSubmitIeOrientation({
    onSuccess: () => {
      Toast.show({
        icon: 'success',
        content: '提交成功',
      })
    },
  })
  const { data: ossSignature } = useGetOssSignature('OWSI')
  const { data: detail, loading: detailRequesting } = useIeDetail()
  const {
    run: getSignatureDetail,
    data: ieSignatureDetail,
    loading: signatureRequesting,
  } = useIeOrientationDetail(code)
  const { formatMessage } = useIntl()

  useEffect(() => {
    if (code === null && detail && detail.code === null) {
      Modal.error({
        title: formatMessage({ id: 'common-errorTitle' }),
        content: formatMessage({ id: 'owsi-not-found' }),
      })
      return
    }
    if (code) getSignatureDetail(code)
  }, [detail])

  if (code === null && detail && detail.code === null) {
    return null
  }

  const submit = () => {
    if (!signature) {
      Toast.show({
        content: '请阅读并完成签名。',
      })
      return
    }
    run({
      code: detail.code,
      handwrittenSignatureLiabilityAgreement: getSubmitOssFormat(signature),
    })
  }

  if (signatureRequesting || detailRequesting) return <DotLoading />

  return (
    <>
      <h2>责任免除和特别风险承担协议书</h2>
      <p>
        <strong>(请仔细阅读以下内容，在空格横线处填写名字并在最后签字)</strong>
      </p>
      <p>本人在此确认已得到忠告并且了解浮潜潜水和水肺潜水本身所存在的风险可能会导致本人严重受伤甚至死亡。</p>
      <p>
        进一步，本人了解潜水时使用压缩空气会有某些潜在的危险:包括但不限于减压病、血管栓塞，或需使用再压舱进行治疗的其它高压伤害。本人也了解，为获得潜水证书进行开放水域潜水训练活动时，潜水地点可能离再压舱很远，或者需要一段时间才能到达，或者两种情况同时存在。尽管如此，本人仍然决定参加潜水训练活动。
      </p>
      <p>
        本人了解并同意，本人之教练考试工作人员、PADI Worldwide Corp., 国际有限公司或这些机构员工、高级职员、代理
        人，或受让人(以下统称「免除责任者」)毋需对本人、家人、继承人或受让人因本人参加此项潜水训练课程/活动，或
        因包括免除责任者在内的任何一方所犯的间接或直接疏失造成的任何伤害、死亡或其它损害，承担任何形式的法律责任和
        义务。
      </p>
      <p>
        做为得以报名参加此项课程/活动的一个交换条件，本人保证在做为学员参加此项课程/活动过程中，对因课程/活动存在的
        风险可能发生在本人身上的一切灾害、伤害或损害，包括一切可预知或意外的风险，本人愿意负全部责任。
      </p>
      <p>
        本人进一步保证，本人、本人家属、遗产继承人或受让人不能在本人参加此项课程/活动时，或在取得潜水证书之后，因
        为本人报名参加此课程/活动而对上述培训班及免除责任者进行任何形式的法律诉讼和赔偿要求。
      </p>
      <p>
        本人也了解，浮潜潜水和水肺潜水是一项极耗费体力的活动，在进行此项课程/活动训练中会出现耗尽体力的情况。若因
        心脏病发、惊慌、换气过度而受伤，本人明确表示自负其责，将不会向上述个人或公司追究责任。
      </p>
      <p>
        本人在此声明并同意此份责任免除书自本人签字当日起壹年之内对于所有PADI 发起的课程和活动/PADI Sponsored Programs
        (包括但是不仅限于 PADI 教练考试-Instructor Examinations) 均属合法生效。
      </p>
      <p>本人进一步声明，本人已到达法定年龄，在法律上有资格签署此份责任免除书。</p>
      <p>本人了解，此份文件规定的条件为契约性条约，并非简单陈述。本人是在自由意志支配下签署此份文件的。</p>
      <p>
        <strong>
          本人欲借此文件声明免除本人之教练考试工作人员、PADI Worldwide Corp.,
          国际有限公司或这些机构员工、高级职员、代理人，或受让人(以下统称「免除责任者」)毋需对本
          人、家人、继承人或受让人因本人参加此项潜水训练课程/活动，或因包括免除责任者在内的任何一方所犯的间接或直接
          疏失造成的任何伤害、死亡或其它损害，承担任何形式的法律责任和义务。本人已经被完全告知并已阅读过，并且完全了
          解「责任免除与特别风险承担书」的内容。
        </strong>
      </p>
      {code ? (
        <>
          <Signature
            title={'候选人签字'}
            initSignature={ieSignatureDetail.handwrittenSignatureLiabilityAgreement}
            modified={false}
          />
          <div className={styles['sign-date']}>
            签名日期：{formatDate(ieSignatureDetail.handwrittenSignatureLiabilityAgreementDate, 'YYYY-MM-DD')}
          </div>
        </>
      ) : (
        <>
          <Signature
            title={'候选人签字'}
            filePath={'signature'}
            modified={true}
            oss={ossSignature}
            onSuccess={(imgUrl) => setSignature(imgUrl)}
            onClear={() => setSignature('')}
          />
          <Button block type="submit" color="primary" loading={loading} onClick={submit}>
            提交
          </Button>
        </>
      )}
    </>
  )
}

export default IeOrientation
